import { Building2, CalendarDays, Users, type LucideIcon } from "lucide-react";
import { RoutePaths, type OrgScopedRouteParams } from "@/config/route-paths";

export type ManageNavItem = {
  labelKey: string;
  descriptionKey?: string;
  icon: LucideIcon;
  href: (params: OrgScopedRouteParams) => string;
  isActive: (pathname: string) => boolean;
};

export const adminNavItems = [
  {
    labelKey: "navigation.organizations",
    icon: Building2,
    href: RoutePaths.organizations.list,
  },
];

export const manageNavItems: ManageNavItem[] = [
  {
    labelKey: "navigation.users",
    descriptionKey: "navigation.usersDescription",
    icon: Users,
    href: RoutePaths.credentials.list,
    isActive: (pathname) => pathname.includes("/credentials"),
  },
  {
    labelKey: "navigation.seasons",
    descriptionKey: "navigation.seasonsDescription",
    icon: CalendarDays,
    href: RoutePaths.seasons.list,
    isActive: (pathname) => pathname.includes("/seasons"),
  },
];
